export type ScheduleDayLayout = 'staff-columns' | 'rail-rooms' | 'rooms'

export type ResolveScheduleDayLayoutArgs = {
  hasEhrBooking: boolean
  isFutureDay: boolean
  railStaffCount: number
  visibleStaffCount: number
}

// Non-OE has a single doctor, so it never shows the rail; staff columns exist only for OE future days.
export const resolveScheduleDayLayout = ({
  hasEhrBooking,
  isFutureDay,
  railStaffCount,
  visibleStaffCount,
}: ResolveScheduleDayLayoutArgs): ScheduleDayLayout => {
  if (!hasEhrBooking) return 'rooms'
  if (isFutureDay && railStaffCount > 0) return 'staff-columns'
  if (visibleStaffCount > 0) return 'rail-rooms'
  return 'rooms'
}
